module.exports = __webpack_public_path__ + "img/stickers-contrat-location.8bee757e.jpg";